import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import DashboardPage from "@/pages/DashboardPage";
import NewAnalysis from "@/pages/NewAnalysis";
import ReportsPage from "@/pages/ReportsPage";
import DocumentsPage from "@/pages/DocumentsPage";
import ExaminerReport from "@/pages/ExaminerReport";
import Profile from "@/pages/Profile";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Community from "@/pages/Community";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import GroupJoin from "@/pages/GroupJoin";
import Pricing from "@/pages/Pricing";
import FeaturesHub from "@/pages/features/FeaturesHub";
import FeaturePage from "@/pages/features/FeaturePage";
import BillingSuccess from "@/pages/BillingSuccess";
import PartnerLandingRoute from "@/pages/PartnerLandingRoute";
import PartnerPortal from "@/pages/PartnerPortal";
import VerifySuccess from "@/pages/VerifySuccess";
import ResetPassword from "@/pages/ResetPassword";
import { AuthProvider } from "@/context/AuthContext";
import { AuthModal } from "@/components/auth/AuthModal";
import { AuthCallback } from "@/components/auth/AuthCallback";

function AppRouter() {
  // Handle the Emergent Google OAuth callback BEFORE normal routing (synchronous, avoids race conditions)
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/new" element={<NewAnalysis />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/documents" element={<DocumentsPage />} />
      <Route path="/report/:id" element={<ExaminerReport />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/cookies" element={<Legal doc="cookies" />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/community" element={<Community />} />
      <Route path="/groups" element={<Groups />} />
      <Route path="/groups/join/:token" element={<GroupJoin />} />
      <Route path="/groups/:id" element={<GroupDetail />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/features" element={<FeaturesHub />} />
      <Route path="/features/:slug" element={<FeaturePage />} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      {/* Partner referral links (P-B) — DB-driven slug, admin-configurable. */}
      <Route path="/r/:slug" element={<PartnerLandingRoute />} />
      <Route path="/topedu" element={<PartnerLandingRoute slug="topedu" />} />
      {/* Partner Portal (P-F) — scoped read-only UI for partner_admin / viewer. */}
      <Route path="/partner" element={<PartnerPortal />} />
      <Route path="/verify-success" element={<VerifySuccess />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <AuthModal />
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
